import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';
import { PageBase, ActivityPeriodSummary, DateValue, RentalInfo, RentalKPI } from 't4core';




@Component({
    styleUrls: ['./home.css'],
    selector: 'home',
    templateUrl: './home.component.html',
})
export class HomeComponent extends PageBase implements OnInit {
    public fromDate: Moment = moment().startOf('month');
    public toDate: Moment = moment().endOf('month');

    public lateBookings: RentalInfo[];

    constructor(el: ElementRef) {
        super(el, "OneWayAdmin");
    }

    public async ngOnInit() {
        this.loadData();
    }

    public loading = {
        late: false
    }

    public async loadData() {
      // Late bookings
      this.loading.late = true;
      this.Api.get<RentalInfo[]>("OneWay/GetLateRentals", { minHours: 3 }).then(x => {
        this.lateBookings = x;

        this.loading.late = false;
      });
      this.fromDate = this.fromDate.clone();
    }
}
